import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service, ApiResponseModel } from '@zayan-erp/shared';
import { catchError, EMPTY, Observable, BehaviorSubject, map } from 'rxjs';
import {
  AgencyRealtor,
  CreateAgencyRealtor,
  UpdateAgencyRealtor,
  AgencyRealtorSearchParams,
  RealtorAgency,
  AgencyRealtorResponse
} from '../models/agency-realtor.models';

@Injectable({
  providedIn: 'root'
})
export class AgencyRealtorService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  realtorUpdated = new BehaviorSubject<boolean>(false);
  realtorUpdated$ = this.realtorUpdated.asObservable();

  getAgencyRealtors(params?: AgencyRealtorSearchParams): Observable<AgencyRealtorResponse> {
    let queryParams = '';
    if (params) {
      const searchParams = new URLSearchParams();
      if (params.search) searchParams.append('search', params.search);
      if (params.agencyId) searchParams.append('agencyId', params.agencyId);
      if (params.cityId) searchParams.append('cityId', params.cityId);
      if (params.salesOfficeId) searchParams.append('salesOfficeId', params.salesOfficeId);
      if (params.pageNumber) searchParams.append('pageNumber', params.pageNumber.toString());
      if (params.pageSize) searchParams.append('pageSize', params.pageSize.toString());
      queryParams = searchParams.toString() ? `?${searchParams.toString()}` : '';
    }

    return this.#http.getData<AgencyRealtorResponse>(`${this.baseUrl}/agency-realtor${queryParams}`, {
      showLoader: true,
      showMessage: false
    });
  }

  getAgencyRealtorById(id: string): Observable<AgencyRealtor> {
    return this.#http.getData<AgencyRealtor>(`${this.baseUrl}/agency-realtor/${id}`, {
      showLoader: true,
      showMessage: false
    });
  }

  createAgencyRealtor(realtor: CreateAgencyRealtor): Observable<AgencyRealtor> {
    return this.#http.postData<AgencyRealtor>(
      `${this.baseUrl}/agency-realtor`,
      { showLoader: true, buttonId: 'save-realtor', showMessage: true },
      realtor
    );
  }

  updateAgencyRealtor(id: string, realtor: UpdateAgencyRealtor): Observable<AgencyRealtor> {
    return this.#http.putData<AgencyRealtor>(`${this.baseUrl}/agency-realtor/${id}`, realtor, {
      showLoader: true,
      buttonId: 'save-realtor',
      showMessage: true
    });
  }

  deleteAgencyRealtor(id: string): Observable<void> {
    return this.#http.deleteData<void>(`${this.baseUrl}/agency-realtor/${id}`, { showLoader: true, showMessage: true });
  }

  getAgencies(): Observable<RealtorAgency[]> {
    return this.#http.getData<RealtorAgency[]>(`${this.baseUrl}/agency`, { showLoader: true, showMessage: false });
  }

  createPublicRealtorRegistration(payload: {
    brokerageName: string;
    agentFirstName: string;
    agentLastName: string;
    phone: string;
    email: string;
    cityId: string;
    captchaToken?: string;
  }): Observable<any> {
    return this.#http.postData<any>(
      `${this.baseUrl}/public/realtor/register`,
      { showLoader: true, showMessage: true },
      payload
    );
  }

  // private handleError(error: any): Observable<never> {
  //   const errorMessage = error.message || 'An error occurred';
  //   this.#toastr.error(errorMessage);
  //   return EMPTY;
  // }
}
